import sal from 'sal.js'

common.View.create('website::layouts.Main', {

    onDOMLoad() {
        this.initSecondMenu();
        this.initAnimations();
        //this.initSecondMenuScroll();
        // this.initCursorEffect();
    },

    initSecondMenu() {
        this.element.find('.mmenuToggler')
            .on('click', (event) => {
                // Set as active
                $(event.currentTarget).toggleClass('is-active');

                // Fade menu
                this.element.find('[class*="main-Secondmenu"] .trigger').fadeToggle('fast');
            });
    },

    initAnimations() {
        sal({
            threshold: 0.01,
            once: true,
        });
    },

    initSecondMenuScroll() {
        let hamburger = this.element.find('.mmenuToggler');

        $(window).scroll(function() {
            let  scroll = $(window).scrollTop();

            if (scroll >= 100) {
                hamburger.addClass("small");
                hamburger.removeClass("big");
            } else {
                hamburger.addClass("big");
                hamburger.removeClass("small");
            }
        }).trigger('scroll');
    },

    initCursorEffect() {
        new fairyDustCursor({
            colors: [
                "#F95455",
                "#4fe672",
                "#F5D61F"
            ]
        });
    }

});
